<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>
        <mat-icon>groups</mat-icon>
        Attendees
      </mat-card-title>
      @if (userCanEdit) {
        <button class="edit-btn" [matTooltip]="isEditMode ? 'Save attendees' : 'Edit event attendees'" (click)="editToggle()">
          @if (!isEditMode) {
            <mat-icon>edit</mat-icon>
          }
          @if (isEditMode) {
            <mat-icon>save</mat-icon>
          }
        </button>
      }
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    @if (isEditMode) {
      <div class="row attendee-edit">
        <div class="header">Add Event Attendees</div>
        <mat-form-field>
          <input matInput name="attendee-search" [matAutocomplete]="auto" [formControl]="searchControl">
          <mat-icon matSuffix>search</mat-icon>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectEmployee($event)">
            @if (employeesLoading) {
              <mat-option>
                <span class="employee-search-load"
                  ><mat-spinner [diameter]="15"></mat-spinner>Loading...</span
                  >
                </mat-option>
              }
              @if (!employeesLoading) {
                @for (attendee of filterEmployees; track attendee) {
                  <div>
                    <mat-option [value]="attendee">{{attendee.name}}</mat-option>
                  </div>
                }
              }
            </mat-autocomplete>
          </mat-form-field>
          @if (selectAttendees.length>0) {
            <div class="col search-results">
              <div class="warning">The following employees will be added to the company event on save:</div>
              <div class="register-toggle"><mat-slide-toggle [formControl]="toggleControl">Automatically register all</mat-slide-toggle></div>
              @for (employee of selectAttendees; track employee) {
                <div class="selected-employees">{{employee.name}}<button matTooltip="Remove attendee" (click)="removeFromSaveList(employee)"><mat-icon>delete</mat-icon></button></div>
              }
            </div>
          }
        </div>
      }
      @if (attendees.length==0) {
        <div class="no-data">There are currently no attendees for this event</div>
      }
      @if (isEditMode && attendees.length>0) {
        <div class="edit-btn-row">
          <button class="edit-btn-register" (click)="registerAll()">Register All<mat-icon>person</mat-icon></button>
          <button class="edit-btn-unregister" (click)="unregisterAll()">Unregister All<mat-icon>person</mat-icon></button>
          <button class="edit-btn-delete" (click)="deleteAll()">Delete All<mat-icon>delete_outline</mat-icon></button>
        </div>
      }
      <div class="row">
        <div class="col-6">
          @if (registeredAttendees.length>0) {
            <div class="attnd-subtitle"><mat-icon class="registered-icon">person</mat-icon>Registered Attendees</div>
          }
        </div>
        @if (unregisteredAttendees.length>0) {
          <div class="col-6">
            <div class="attnd-subtitle"><mat-icon class="unregistered-icon">person</mat-icon>Unregistered Attendees</div>
          </div>
        }
      </div>
      @if (attendees.length>0) {
        <div class="row attendees-list">
          <div class="col-6 registered-list">
            <mat-list>
              @for (registered of registeredAttendees; track registered) {
                <mat-list-item>
                  <company-events-attendee-tile
                    [attendee]="registered"
                    [isRegistered]="true"
                    [isEditMode]="isEditMode"
                    (register)="editRegistration($event)"
                    (sendOutlookInvite)="sendOutlookInvite($event)"
                    (removeAttendee)="deleteAttendee($event)"
                  ></company-events-attendee-tile>
                </mat-list-item>
              }
            </mat-list>
          </div>
          <div class="col-6 unregistered-list">
            <mat-list>
              @for (unregistered of unregisteredAttendees; track unregistered) {
                <mat-list-item>
                  <company-events-attendee-tile
                    [attendee]="unregistered"
                    [isRegistered]="false"
                    [isEditMode]="isEditMode"
                    (register)="editRegistration($event)"
                    (sendOutlookInvite)="sendOutlookInvite($event)"
                    (removeAttendee)="deleteAttendee($event)"
                  ></company-events-attendee-tile>
                </mat-list-item>
              }
            </mat-list>
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
